/* models/text_input.js */ function _(require, module, exports, __esModule, __esExport) {
    var _a, _b;
    __esModule();
    const text_input_1 = require("@bokehjs/models/widgets/text_input");
    const bokeh_events_1 = require("@bokehjs/core/bokeh_events");
    class EnterEvent extends bokeh_events_1.ModelEvent {
        constructor(value_input) {
            super();
            this.value_input = value_input;
        }
        get event_values() {
            return { model: this.origin, value_input: this.value_input };
        }
    }
    exports.EnterEvent = EnterEvent;
    _a = EnterEvent;
    EnterEvent.__name__ = "EnterEvent";
    (() => {
        _a.prototype.event_name = "enter-pressed";
    })();
    class TextInputView extends text_input_1.TextInputView {
        _keyup(event) {
            super._keyup(event);
            if (event.key == "Enter") {
                const { value_input } = this.model;
                this.model.trigger_event(new EnterEvent(value_input));
            }
        }
    }
    exports.TextInputView = TextInputView;
    TextInputView.__name__ = "TextInputView";
    class TextInput extends text_input_1.TextInput {
        constructor(attrs) {
            super(attrs);
        }
    }
    exports.TextInput = TextInput;
    _b = TextInput;
    TextInput.__name__ = "TextInput";
    TextInput.__module__ = "panel.models.widgets";
    (() => {
        _b.prototype.default_view = TextInputView;
        _b.define(({}) => ({}));
    })();
}
